import script from "./RemittancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./RemittancePage.vue?vue&type=script&setup=true&lang=js"

import "./RemittancePage.vue?vue&type=style&index=0&id=bba3c26c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba3c26c"]])

export default __exports__